import React from 'react'
import Cookies from "js-cookie";
import { CloseIcon } from "~/assets/svg";
import { getLocalizedVal } from '~/tools/localization/helpers'
import './style.scss'

class CookieConsent extends React.Component {
  constructor(){
    super()
    this.state = {
      showCC: null
    }
    this.addCookie = this.addCookie.bind(this)
    this.changeCCState = this.changeCCState.bind(this)
  }

  componentDidMount(){
    this.addCookie()
    if(Cookies.get('showCC')) {
      this.setState({showCC: 1})
    }
  }

  render() {
    if (this.state.showCC === 1) 
      return <div/>
     let learnMoreLink = (window.settings.navigation.settings && window.settings.navigation.settings.primaryCta && window.settings.navigation.settings.primaryCta.learnMore) || "/privacy-policy"
    return (
      <div 
        className="cookie-consent" 
        tabIndex="1" 
        role="dialog" 
        aria-describedby="cookie-consent-desc" 
        aria-label="cookieconsent"
      >
        <div id="cookie-consent-desc" className="desc">{getLocalizedVal(window.settings, 'genericMessages', 'cookiesDisclaimer') || 'This website uses cookies to ensure you get the best experience on our website. '}
           <a target="_blank" tabIndex="1" rel="noopener noreferrer" href={learnMoreLink}>{getLocalizedVal(window.settings,'genericMessages','learnMore') || 'Learn More'}</a>
        </div>
        <div 
          aria-label="Accept cookie consent" 
          tabIndex="1" 
          className="close-button" 
          onKeyPress={this.changeCCState} 
          onClick={this.changeCCState}
        > 
          <CloseIcon/> 
        </div>
      </div>
    )
  }

  addCookie(){
    Cookies.set('cc', 1, { expires: 365 })
  }
  changeCCState() {
    Cookies.set('showCC', 1, { expires: 365 })
    this.setState({showCC: 1})
  }
}

export default CookieConsent;
